import TreeNodeModal from '../tree/tree-node-model';

export const getLabelPathStrByModel = (nodeModel, optionLabel, separator = '') => {
  const nodePath = nodeModel.getNodePath();
  const dataPath = nodePath.map((node) => node.data);
  const labelPath = dataPath.map((data) => data[optionLabel]).join(separator);
  return labelPath;
};

export const addChild = (parentModel, childrenData, optionValue, optionChildren) => {
  const getKey = (data) => data[optionValue];
  const getChildren = (data) => data[optionChildren];

  if (Array.isArray(childrenData)) {
    childrenData.forEach((childNode) => {
      const key = getKey(childNode);
      const children = getChildren(childNode);
      const isLeaf = Boolean(!children);
      const nodeModel = new TreeNodeModal({ key, isLeaf, data: childNode });
      parentModel.addChild(nodeModel, false);
    });
  }
};
